// extracted by mini-css-extract-plugin
export default {"container":"gH-z","header":"hH-z","details":"iH-z","link":"jH-z"};